module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAbFBMVEUAAAAfn/8foP8foP8fn/8blf8enf8Kj/8Ukv8foP8foP8foP8fn/8bm/8fn/8eoP8en/8fn/8Xl/8foP8fn/8fn/8fn/8eoP8cnf8dnf8anP8amf8fn/8fn/8fn/8fn/8fnv8en/8enf8dn/9OCOehAAAAJHRSTlMAt9J7pRI8Bgzg2qqjHM93ak0W/sCHVkM2LCEU7bqakox/XjWwKxaEAAAAjElEQVQY063Pyw6CMBCF4UMr9Aq05Q7eff93FFvTIDWu/DeTfJnFDMBo9lE3Y0Vz8GkdZl1iE0NS2Z3s3nLdNGLY7SmRyazq2camVti6spoYHq0gZMwpKcqLpHkgNoh2xgux3OSVe7sflUNAcCOpwzrVmQNvBOvVFI/2mPwQEf/D5etmXY1Icg+GXz0BrxYF1DAvXj8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/HandleTop.png
// module id = V5hE
// module chunks = 104